// extracted by mini-css-extract-plugin
export default {"button":"TryAgain_button__gFxoR","innerContainer":"TryAgain_innerContainer__DaURW","img":"TryAgain_img__Up0u9","container":"TryAgain_container__XPxdF"};